import { gql } from '@apollo/client';

export default gql`
  mutation addPassengers($bookingReference: String!, $passengers: [InputPassengerBrief]!) {
    addPassengers(bookingReference: $bookingReference, passengersList: $passengers)
  }
`;
